export async function delayedPromise(delayMs: number) {
  return new Promise((resolve) => {
    setTimeout(() => resolve('OK'), delayMs);
  });
}
